import styled from 'styled-components'

export const Content = styled.div`
  margin-top: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const LineDescription = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const LineLabelsWrapper = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
  }
`
